import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonCopyText } from '@components/atoms/button-copy-text';
import { Typography } from '@components/atoms/typography';
import { QrCode } from '@components/moleculs/qr-code';
import { TextField } from '@components/moleculs/text-field';
import { Header } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/header';
import { useCustomPartnerFetchStatus } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/hooks/use-custom-partner-fetch-status';
import { useVerificationUrl } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/hooks/use-verification-url';
import { useAppSelector } from '@store';

import { DesktopNotAllowedContainer } from './styles';

export const DesktopNotAllowedStep: React.FC = () => {
    const { t } = useTranslation();
    const { verificationUrl } = useVerificationUrl();
    const sdkOptions = useAppSelector((state) => state.docsVerification.sdkOptions);
    const concordium = sdkOptions?.customPartner?.concordium;

    useCustomPartnerFetchStatus();

    return (
        <DesktopNotAllowedContainer>
            <Header />
            <div className='not-allowed-container'>
                <Typography tag='h2' variant='h2' className='title'>
                    {t('docVerificationWidget.desktopNotAllowed.title')}
                </Typography>
                <Typography tag='div' variant='text-bold' color='text-light' className='sub-title'>
                    {t('docVerificationWidget.qrLink.text')}
                </Typography>
                <div className='qr-container'>
                    <QrCode value={verificationUrl} size={135} />
                </div>
                {!!concordium && (
                    <Typography
                        tag='div'
                        variant='text-medium'
                        color='text-light'
                        sx={{ mt: 2, textAlign: 'center' }}
                    >
                        {t('docVerificationWidget.desktopNotAllowed.dontClose')}
                    </Typography>
                )}
                <TextField
                    disabled={true}
                    fullWidth={true}
                    value={verificationUrl}
                    InputProps={{
                        endAdornment: (
                            <ButtonCopyText
                                copyText={verificationUrl}
                                tooltipProps={{
                                    title: t('common.copied'),
                                    placement: 'bottom',
                                }}
                                className='icon'
                            />
                        ),
                    }}
                    inputSize='m'
                    className='link-field'
                />
            </div>
        </DesktopNotAllowedContainer>
    );
};
